<nav class="navbar navbar-expand-lg navbar-light navbar-custom fixed-top">
  <div class="container">
    <!-- Brand/Logo -->
    <a class="navbar-brand fw-bold text-gradient" href="/">
      <i class="fas fa-code me-2"></i>Stradetskyi
    </a>

    <!-- Mobile menu toggle -->
    <button
      class="navbar-toggler"
      type="button"
      (click)="toggleMenu()"
      [attr.aria-expanded]="isMenuOpen"
      aria-controls="navbarNav"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navigation menu -->
    <div class="navbar-collapse" [class.collapse]="!isMenuOpen" id="navbarNav">
      <ul class="navbar-nav ms-auto align-items-center">
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('home')" href="#home">
            {{ getTranslation('nav.home') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('about')" href="#about">
            {{ getTranslation('nav.about') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('services')" href="#services">
            {{ getTranslation('nav.services') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('skills')" href="#skills">
            {{ getTranslation('nav.skills') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('experience')" href="#experience">
            {{ getTranslation('nav.experience') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('cases')" href="#cases">
            {{ getTranslation('nav.cases') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('process')" href="#process">
            {{ getTranslation('nav.process') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('location')" href="#location">
            {{ getTranslation('nav.location') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('testimonials')" href="#testimonials">
            {{ getTranslation('nav.testimonials') }}
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="scrollToSection('contact')" href="#contact">
            {{ getTranslation('nav.contact') }}
          </a>
        </li>

        <!-- Language switcher -->
        <li class="nav-item ms-3">
          <button
            class="btn btn-outline-primary btn-sm"
            (click)="toggleLanguage()"
            [title]="currentLanguage === 'en' ? 'Switch to Ukrainian' : 'Перемкнути на англійську'">
            {{ currentLanguage === 'en' ? 'UA' : 'EN' }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</nav>
